module.exports = __webpack_public_path__ + "static/media/largeFont.3129c432.webp";